/* eslint-disable no-unused-vars */
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DragNDrop from './dragndroplistcomponent';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import PageTitle from './layout/PageTitle';
import { ListGroup, ListGroupItem } from 'react-bootstrap';

export default function Project() {
  const { id } = useParams();
  const [projectName, setProjectName] = useState([]);
  const [prefixes, setPrefixes] = useState([]);
  const [times, setTimes] = useState([]);
  const [dividers, setDividers] = useState([]);
  const [players, setPlayers] = useState([]);
  const [playtypes, setPlaytypes] = useState([]);
  const [qualitys, setQualitys] = useState([]);
  const [extensions, setExtensions] = useState([]);
  const [filename, setFilename] = useState([]);
  const [copiedAlert, setCopiedAlert] = useState(false);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [que, setQue] = useState([]);

  const handleDataFromChild = (data) => {
    setFilename(data);
  };

  useEffect(() => {
    getProject();
  }, [id]); // Only run when id changes

  function getProject() {
    axios.get(`https://filenamebuilder.com/api/project.php/${id}`).then(function (response) {
      setProjectName(response.data[0].project.name);
      setPrefixes(response.data[0].prefixes.sort((a, b) => a.name.localeCompare(b.name)));
      setTimes(response.data[0].times.sort((a, b) => a.name.localeCompare(b.name)));
      setDividers(response.data[0].dividers.sort((a, b) => a.name.localeCompare(b.name)));
      setPlayers(response.data[0].players.sort((a, b) => a.name.localeCompare(b.name)));
      setPlaytypes(response.data[0].playtypes.sort((a, b) => a.name.localeCompare(b.name)));
      setQualitys(response.data[0].qualitys.sort((a, b) => a.name.localeCompare(b.name)));
      setExtensions(response.data[0].extensions);
      // Ensure que is always an array and avoid undefined errors
      let queData = [];
      if (
        response.data[0].que &&
        Array.isArray(response.data[0].que) &&
        response.data[0].que[0] &&
        typeof response.data[0].que[0].que !== 'undefined'
      ) {
        queData = response.data[0].que[0].que;
        if (typeof queData === 'string') {
          queData = queData
            .split(',')
            .map((item) => item.trim())
            .filter((item) => item.length > 0);
        }
      }
      setQue(queData);
    });
  }

  const handleAddPrefixSubmit = (event) => {
    event.preventDefault();
    const inputs = { project_id: id, name: event.target.prefix.value };
    axios
      .post(`https://filenamebuilder.com/api/project.php/prefix`, inputs)
      .then(function (response) {
        if (response.data.status === 1) {
          event.target.prefix.value = '';
        }
        getProject();
      });
  };
  const handleAddTimeSubmit = (event) => {
    event.preventDefault();
    const inputs = { project_id: id, name: event.target.time.value };
    axios
      .post(`https://filenamebuilder.com/api/project.php/time`, inputs)
      .then(function (response) {
        if (response.data.status === 1) {
          event.target.time.value = '';
        }
        getProject();
      });
  };
  const handleAddDividerSubmit = (event) => {
    event.preventDefault();
    const inputs = { project_id: id, name: event.target.divider.value };
    axios
      .post(`https://filenamebuilder.com/api/project.php/divider`, inputs)
      .then(function (response) {
        if (response.data.status === 1) {
          event.target.divider.value = '';
        }
        getProject();
      });
  };
  const handleAddPlayerSubmit = (event) => {
    event.preventDefault();
    const inputs = { project_id: id, name: event.target.player.value };
    axios
      .post(`https://filenamebuilder.com/api/project.php/player`, inputs)
      .then(function (response) {
        if (response.data.status === 1) {
          event.target.player.value = '';
        }
        getProject();
      });
  };
  const handleAddPlayTypeSubmit = (event) => {
    event.preventDefault();
    const inputs = { project_id: id, name: event.target.description.value };
    axios
      .post(`https://filenamebuilder.com/api/project.php/playtype`, inputs)
      .then(function (response) {
        if (response.data.status === 1) {
          event.target.description.value = '';
        }
        getProject();
      });
  };
  const handleAddQualitySubmit = (event) => {
    event.preventDefault();
    const inputs = { project_id: id, name: event.target.quality.value };
    axios
      .post(`https://filenamebuilder.com/api/project.php/quality`, inputs)
      .then(function (response) {
        if (response.data.status === 1) {
          event.target.quality.value = '';
        }
        getProject();
      });
  };
  const handleAddExtensionSubmit = (event) => {
    event.preventDefault();
    const inputs = { project_id: id, name: event.target.extension.value };
    axios
      .post(`https://filenamebuilder.com/api/project.php/extension`, inputs)
      .then(function (response) {
        if (response.data.status === 1) {
          event.target.extension.value = '';
        }
        getProject();
      });
  };
  const handleAddQueSubmit = (event) => {
    event.preventDefault();
    // Add the new que item to the que state (append to end of array)
    setQue((prevItems) => [...prevItems, event.target.que.value]);
    // Convert que to a string for the API
    const inputs = { project_id: id, que: [...que, event.target.que.value].toString() };
    console.log(inputs);
    axios.post(`https://filenamebuilder.com/api/project.php/que`, inputs).then(function (response) {
      console.log(response);
      getProject();
    });
  };

  const handleDeletePrefixClick = (prefix_id) => {
    axios
      .delete(`https://filenamebuilder.com/api/project.php/prefix/${prefix_id}`)
      .then(function (response) {
        //navigate(`/project/${id}`);
        getProject();
      });
  };
  const handleDeleteTimeClick = (prefix_id) => {
    axios
      .delete(`https://filenamebuilder.com/api/project.php/time/${prefix_id}`)
      .then(function (response) {
        //navigate(`/project/${id}`);
        getProject();
      });
  };
  const handleDeleteDividerClick = (prefix_id) => {
    axios
      .delete(`https://filenamebuilder.com/api/project.php/divider/${prefix_id}`)
      .then(function (response) {
        //navigate(`/project/${id}`);
        getProject();
      });
  };
  const handleDeletePlayerClick = (player_id) => {
    axios
      .delete(`https://filenamebuilder.com/api/project.php/player/${player_id}`)
      .then(function (response) {
        //navigate(`/project/${id}`);
        getProject();
      });
  };
  const handleDeletePlayTypeClick = (playtype_id) => {
    axios
      .delete(`https://filenamebuilder.com/api/project.php/playtype/${playtype_id}`)
      .then(function (response) {
        //navigate(`/project/${id}`);
        getProject();
      });
  };
  const handleDeleteQualityClick = (quality_id) => {
    axios
      .delete(`https://filenamebuilder.com/api/project.php/quality/${quality_id}`)
      .then(function (response) {
        //navigate(`/project/${id}`);
        getProject();
      });
  };
  const handleDeleteExtensionClick = (extension_id) => {
    axios
      .delete(`https://filenamebuilder.com/api/project.php/extension/${extension_id}`)
      .then(function (response) {
        //navigate(`/project/${id}`);
        getProject();
      });
  };

  const handlePrefixClick = (prefixName) => {
    setFilename((prevItems) => [...prevItems, prefixName]);
  };
  const handleTimeClick = (timeName) => {
    setFilename((prevItems) => [...prevItems, timeName]);
  };
  const handleDividerClick = (dividerName) => {
    setFilename((prevItems) => [...prevItems, dividerName]);
  };
  const handlePlayerClick = (playerName) => {
    setFilename((prevItems) => [...prevItems, playerName]);
  };
  const handlePlayerTypeClick = (playerType) => {
    setFilename((prevItems) => [...prevItems, playerType]);
  };
  const handleQualityClick = (quality) => {
    setFilename((prevItems) => [...prevItems, quality]);
  };
  const handleExtensionClick = (extension) => {
    setFilename((prevItems) => [...prevItems, extension]);
  };

  const joinArrayExceptLast = (arr, separator, lastSeparator) => {
    if (arr.length <= 1) {
      return arr.join('');
    }
    const allButLast = arr.slice(0, -1).join(separator);
    const lastElement = arr[arr.length - 1];
    return `${allButLast}${lastSeparator}${lastElement}`;
  };

  const copyToClipboard = () => {
    var copyText = document.getElementById('que');
    copyText.select();
    copyText.setSelectionRange(0, 99999); // For mobile devices
    navigator.clipboard.writeText(copyText.value);
    setCopiedAlert(!copiedAlert);
  };

  const handleCopyQueueItem = (index) => {
    if (que[index]) {
      navigator.clipboard.writeText(que[index]);
      setCopiedIndex(index);
      setCopiedAlert(true);
      setTimeout(() => {
        setCopiedIndex(null);
        setCopiedAlert(false);
      }, 4000);
    }
  };

  const handleClearAll = () => {
    setFilename([]);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setCopiedAlert(false);
    }, 2000);

    // Cleanup function to clear the timeout if the component unmounts or the dependencies change
    return () => clearTimeout(timer);
  }, [copiedAlert]); // Dependency array ensures the effect runs only when 'value' changes

  return (
    <>
      <PageTitle title={`${projectName}`} />
      <Row>
        <Col>
          <h4>Create</h4>
          <p>
            <small>
              Create list items for each category. Select the list items to populate the filename. X
              to delete the list item.
            </small>
          </p>
          <Table responsive bordered size="sm">
            <thead className="table-dark">
              <tr>
                <th>Prefix</th>
                <th>Time</th>
                <th>Divider</th>
                <th>Player</th>
                <th>Description</th>
                <th>Quality</th>
                <th>Extension</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <form onSubmit={handleAddPrefixSubmit}>
                    <div className="input-group">
                      <input
                        type="text"
                        id="prefix"
                        name="prefix"
                        className="form-control"
                        placeholder="prefix"
                      />
                      <input type="number" name="project_id" value={id} disabled hidden />
                      <span
                        className="input-group-text"
                        id="basic-addon1"
                        style={{ padding: 0, height: '46px', background: '#0d6efd' }}
                      >
                        <Button size="sm" type="submit" className="form-control">
                          +
                        </Button>
                      </span>
                    </div>
                  </form>
                </td>
                <td>
                  <form onSubmit={handleAddTimeSubmit}>
                    <div className="input-group">
                      <input
                        type="text"
                        id="time"
                        name="time"
                        className="form-control"
                        placeholder="time"
                      />
                      <input type="number" name="project_id" value={id} disabled hidden />
                      <span
                        className="input-group-text"
                        id="basic-addon1"
                        style={{ padding: 0, height: '46px', background: '#0d6efd' }}
                      >
                        <Button size="sm" type="submit" className="form-control">
                          +
                        </Button>
                      </span>
                    </div>
                  </form>
                </td>
                <td>
                  <form onSubmit={handleAddDividerSubmit}>
                    <div className="input-group">
                      <input
                        type="text"
                        id="divider"
                        name="divider"
                        className="form-control"
                        placeholder="divider"
                      />
                      <input type="number" name="project_id" value={id} disabled hidden />
                      <span
                        className="input-group-text"
                        id="basic-addon1"
                        style={{ padding: 0, height: '46px', background: '#0d6efd' }}
                      >
                        <Button size="sm" type="submit" className="form-control">
                          +
                        </Button>
                      </span>
                    </div>
                  </form>
                </td>
                <td>
                  <form onSubmit={handleAddPlayerSubmit}>
                    <div className="input-group">
                      <input
                        type="text"
                        id="player"
                        name="player"
                        className="form-control"
                        placeholder="name"
                      />
                      <input type="number" name="project_id" value={id} disabled hidden />
                      <span
                        className="input-group-text"
                        id="basic-addon2"
                        style={{ padding: 0, height: '46px', background: '#0d6efd' }}
                      >
                        <Button size="sm" type="submit" className="form-control">
                          +
                        </Button>
                      </span>
                    </div>
                  </form>
                </td>
                <td>
                  <form onSubmit={handleAddPlayTypeSubmit}>
                    <div className="input-group">
                      <input
                        type="text"
                        id="description"
                        name="description"
                        className="form-control"
                        placeholder="description"
                      />
                      <input type="number" name="project_id" value={id} disabled hidden />
                      <span
                        className="input-group-text"
                        id="basic-addon3"
                        style={{ padding: 0, height: '46px', background: '#0d6efd' }}
                      >
                        <Button size="sm" type="submit" className="form-control">
                          +
                        </Button>
                      </span>
                    </div>
                  </form>
                </td>
                <td>
                  <form onSubmit={handleAddQualitySubmit}>
                    <div className="input-group">
                      <input
                        type="text"
                        id="quality"
                        name="quality"
                        className="form-control"
                        placeholder="quality"
                      />
                      <input type="number" name="project_id" value={id} disabled hidden />
                      <span
                        className="input-group-text"
                        id="basic-addon4"
                        style={{ padding: 0, height: '46px', background: '#0d6efd' }}
                      >
                        <Button size="sm" type="submit" className="form-control">
                          +
                        </Button>
                      </span>
                    </div>
                  </form>
                </td>
                <td>
                  <form onSubmit={handleAddExtensionSubmit}>
                    <div className="input-group">
                      <input
                        type="text"
                        id="extension"
                        name="extension"
                        className="form-control"
                        placeholder="extension"
                      />
                      <input type="number" name="project_id" value={id} disabled hidden />
                      <span
                        className="input-group-text"
                        id="basic-addon5"
                        style={{ padding: 0, height: '46px', background: '#0d6efd' }}
                      >
                        <Button size="sm" type="submit" className="form-control">
                          +
                        </Button>
                      </span>
                    </div>
                  </form>
                </td>
              </tr>
              <tr>
                <td>
                  {prefixes.map((prefix, key) => (
                    <div
                      key={key}
                      className="btn-group"
                      role="group"
                      aria-label="prefixes"
                      style={{ display: 'block', marginBottom: '5px' }}
                    >
                      <Button
                        className="btn-small active"
                        onClick={() => handlePrefixClick(prefix.name)}
                      >
                        {prefix.name}
                      </Button>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => handleDeletePrefixClick(prefix.id)}
                      >
                        X
                      </Button>
                    </div>
                  ))}
                </td>
                <td>
                  {times.map((time, key) => (
                    <div
                      key={key}
                      className="btn-group"
                      role="group"
                      aria-label="times"
                      style={{ display: 'block', marginBottom: '5px' }}
                    >
                      <Button
                        className="active"
                        size="sm"
                        onClick={() => handleTimeClick(time.name)}
                      >
                        {time.name}
                      </Button>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => handleDeleteTimeClick(time.id)}
                      >
                        X
                      </Button>
                    </div>
                  ))}
                </td>
                <td>
                  {dividers.map((divider, key) => (
                    <div
                      key={key}
                      className="btn-group"
                      role="group"
                      aria-label="divider"
                      style={{ display: 'block', marginBottom: '5px' }}
                    >
                      <Button
                        className="active"
                        size="sm"
                        onClick={() => handleDividerClick(divider.name)}
                      >
                        {divider.name}
                      </Button>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => handleDeleteDividerClick(divider.id)}
                      >
                        X
                      </Button>
                    </div>
                  ))}
                </td>
                <td>
                  {players.map((player, key) => (
                    <div
                      key={key}
                      className="btn-group"
                      role="group"
                      aria-label="players"
                      style={{ display: 'block', marginBottom: '5px' }}
                    >
                      <Button
                        className="active"
                        size="sm"
                        onClick={() => handlePlayerClick(player.name)}
                      >
                        {player.name}
                      </Button>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => handleDeletePlayerClick(player.id)}
                      >
                        X
                      </Button>
                    </div>
                  ))}
                </td>
                <td>
                  {playtypes.map((playtype, key) => (
                    <div
                      key={key}
                      className="btn-group"
                      role="group"
                      aria-label="description"
                      style={{ display: 'block', marginBottom: '5px' }}
                    >
                      <Button
                        className="active"
                        size="sm"
                        onClick={() => handlePlayerTypeClick(playtype.name)}
                      >
                        {playtype.name}
                      </Button>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => handleDeletePlayTypeClick(playtype.id)}
                      >
                        X
                      </Button>
                    </div>
                  ))}
                </td>
                <td>
                  {qualitys.map((quality, key) => (
                    <div
                      key={key}
                      className="btn-group"
                      role="group"
                      aria-label="quality"
                      style={{ display: 'block', marginBottom: '5px' }}
                    >
                      <Button
                        className="active"
                        size="sm"
                        onClick={() => handleQualityClick(quality.name)}
                      >
                        {quality.name}
                      </Button>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => handleDeleteQualityClick(quality.id)}
                      >
                        X
                      </Button>
                    </div>
                  ))}
                </td>
                <td>
                  {extensions.map((extension, key) => (
                    <div
                      key={key}
                      className="btn-group"
                      role="group"
                      aria-label="extensions"
                      style={{ display: 'block', marginBottom: '5px' }}
                    >
                      <Button
                        className="active"
                        size="sm"
                        onClick={() => handleExtensionClick(extension.name)}
                      >
                        {extension.name}
                      </Button>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => handleDeleteExtensionClick(extension.id)}
                      >
                        X
                      </Button>
                    </div>
                  ))}
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <h3>Refine</h3>
          <p>
            <small>Drag-n-Drop selections to change the order. X to remove.</small>
          </p>
          <div className="mb-3">
            <DragNDrop filename={filename} onDataChange={handleDataFromChild} />
          </div>
          <form onSubmit={handleAddQueSubmit}>
            <div className="d-flex align-items-center">
              <span className="bg-warning text-white px-2 py-1 shadow">
                {joinArrayExceptLast(filename, ' ', '')}
              </span>
              <input
                type="text"
                id="que"
                name="que"
                readOnly
                className="form-control-plaintext"
                value={joinArrayExceptLast(filename, ' ', '')}
                style={{ minWidth: 0 }}
                hidden
              />
              <input type="number" id="project_id" name="project_id" value={id} disabled hidden />
              <div className="ms-auto d-flex gap-2">
                <Button size="sm" variant="secondary" type="button" onClick={handleClearAll}>
                  Clear
                </Button>
                <Button size="sm" onClick={() => copyToClipboard()}>
                  Copy
                </Button>
                <Button size="sm" type="submit">
                  Add To Queue
                </Button>
              </div>
            </div>
          </form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <hr />
          <h3>Queue</h3>
          <ListGroup className="list-group">
            {que.map((item, index) => (
              <ListGroupItem
                type="button"
                className={`list-group-item list-group-item-action${copiedIndex === index ? ' active' : ''}`}
                key={index}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span>{item}</span>
                  <div className="d-flex gap-2">
                    <Button size="sm" onClick={() => handleCopyQueueItem(index)}>
                      Copy
                    </Button>
                    <Button
                      size="sm"
                      variant="secondary"
                      onClick={() => {
                        const newQue = que.filter((_, i) => i !== index);
                        setQue(newQue);
                        // Convert updated que to a string for the API
                        const inputs = { project_id: id, que: newQue.toString() };
                        axios
                          .post(`https://filenamebuilder.com/api/project.php/que`, inputs)
                          .then(function () {
                            getProject();
                          });
                      }}
                    >
                      X
                    </Button>
                  </div>
                </div>
              </ListGroupItem>
            ))}
          </ListGroup>
        </Col>
      </Row>
    </>
  );
}
